import { UI_ACTIONS } from '../app/data/constants';

const setupActions = (uiManager) => {
  Object.keys(UI_ACTIONS).forEach((key) => {
    uiManager.addUiAction(UI_ACTIONS[key].name)
  });
}

export default setupActions;
